import destaque from '../assets/medalhas/destaque.svg';
import elite from '../assets/medalhas/elite.svg';
import excelencia from '../assets/medalhas/excelencia.svg';
import progresso from '../assets/medalhas/progresso.svg';
import iniciante from '../assets/medalhas/revelacao.svg';
import revelacao from '../assets/medalhas/revelacao.svg';
import destaqueProgress from '../assets/progresso/destaque.svg';
import eliteProgress from '../assets/progresso/elite.svg';
import excelenciaProgress from '../assets/progresso/excelencia.svg';
import progressoProgress from '../assets/progresso/progresso.svg';
import inicianteProgress from '../assets/progresso/revelacao.svg';
import revelacaoProgress from '../assets/progresso/revelacao.svg';

export const classificacao = [
  {
    number: 1,
    current: false,
    description: 'Revelação',
    text: '25% dos nossos corretores ocuparam esta posição.',
    value: 0,
    maxValue: 99,
    imageProgressSrc: revelacaoProgress,
    imageSrc: revelacao
  },
  {
    number: 2,
    current: false,
    description: 'Evolução',
    text: '40% dos nossos corretores ocuparam esta posição.',
    value: 100,
    maxValue: 149,
    imageProgressSrc: progressoProgress,
    imageSrc: progresso
  },
  {
    number: 3,
    current: false,
    description: 'Destaque',
    text: '28% dos nossos corretores ocuparam esta posição.',
    value: 150,
    maxValue: 219,
    imageProgressSrc: destaqueProgress,
    imageSrc: destaque
  },
  {
    number: 4,
    current: false,
    description: 'Excelência',
    text: '6% dos nossos corretores ocuparam esta posição.',
    value: 220,
    maxValue: 269,
    imageProgressSrc: excelenciaProgress,
    imageSrc: excelencia
  },
  {
    number: 5,
    current: false,
    description: 'Elite',
    text: '1% dos nossos corretores ocuparam esta posição.',
    value: 270,
    maxValue: 315,
    imageProgressSrc: eliteProgress,
    imageSrc: elite
  }
];
